import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import lodash from 'lodash';
import authUtil from 'util/auth';
import PropTypes from 'prop-types';

const AuthControl = (props) => {
   const [hasFieldPrivilege, setHasFieldPrivilege] = useState();
   const [hasRolePrivilege, setHasRolePrivilege] = useState();

   // Validate if user has FieldPrivilege
   useEffect(() => {
      const {
         field,
         privileges,
      } = props;
      const hasNoFieldRestriction = !field;
      setHasFieldPrivilege(hasNoFieldRestriction || (privileges && privileges[field]));
   }, [props.privileges, props.field]);

   // validate if user has rolePrivilege
   useEffect(() => {
      const {
         rolesVisibleTo,
         user,
         userPartner,
      } = props;

      const employerRolesVisibleTo = lodash.isArray(rolesVisibleTo?.employer)
         ? rolesVisibleTo.employer
         : [];

      const partnerRolesVisibleTo = lodash.isArray(rolesVisibleTo?.partner)
         ? rolesVisibleTo.partner
         : [];

      const hasNoRoleRestriction = employerRolesVisibleTo.length === 0 && partnerRolesVisibleTo.length === 0;

      if (hasNoRoleRestriction) {
         setHasRolePrivilege(true);
      } else {
         setHasRolePrivilege(
            authUtil.userRolesInRolesVisibleTo(user.roles, employerRolesVisibleTo)
            || authUtil.userRolesInRolesVisibleTo(userPartner.roles, partnerRolesVisibleTo),
         );
      }
   }, [props.user.roles, props.rolesVisibleTo, props.userPartner.roles, props.roleScope]);

   return (
      (hasFieldPrivilege && hasRolePrivilege)
         ? props.children : null
   );
};

AuthControl.propTypes = {
   rolesVisibleTo: PropTypes.shape({
      employer: PropTypes.arrayOf(PropTypes.string),
      partner: PropTypes.arrayOf(PropTypes.string),
   }),
   field: PropTypes.string,
};

AuthControl.defaultProps = {
   rolesVisibleTo: {
      employer: [],
      partner: [],
   },
   field: undefined,
};

const mapStateToProps = (state) => ({
   user: state.authReducer.loggedInUser,
   userPartner: state.authReducer.loggedInUserPartner,
   privileges: state.privilegeReducer.privileges,
});

export default connect(
   mapStateToProps,
   null,
)(AuthControl);
